"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const PopoverPortal = ({ children, selector, disabled = false }) => {
    const ref = react_1.useRef();
    const [mounted, setMounted] = react_1.useState(false);
    react_1.useEffect(() => {
        var _a;
        ref.current = (_a = document.querySelector(selector)) !== null && _a !== void 0 ? _a : undefined;
        setMounted(true);
    }, [selector]);
    if (disabled) {
        return children;
    }
    return mounted && ref.current ? react_dom_1.createPortal(children, ref.current) : null;
};
exports.default = PopoverPortal;
